import { useEffect } from "react";
import { useSelector } from "react-redux";

import { grantProductAnalyticsConsent } from "lib/analytics/product-analytics-consent";
import type { AppState } from "store/reducers/Reducer";

export const ProductAnalyticsConsentSync = () => {
  const loggedIn = useSelector((state: AppState) => state.auth.loggedIn);

  useEffect(() => {
    if (!loggedIn) {
      return;
    }

    grantProductAnalyticsConsent();
  }, [loggedIn]);

  return null;
};
